<section class="twofactor-social">
  <div class="form-group">
    <div class="title">
      <label class="h5">{{'Two-Factor Authentication' | translate}}</label>
      <span class="icon" (click)="twoFactorInfo.toggle($event)" (mouseenter)="twoFactorInfo.toggle($event)" (mouseleave)="twoFactorInfo.toggle($event)">
        <i class="fa fa fa-info-circle" aria-hidden="true"></i>
      </span>
    </div>
  </div>
  <div class="page-filter clearfix account">
    <div class="index-content page-account page-plan">
      <div class="form-group">
        <div class="flex">
          <div class="title-content">
            <label>{{'Two-Factor Authentication' | translate}}</label>
            <small>{{'Switch to enable / disable two-factor authentication in both PowerPanel Cloud App and Website' | translate}}</small>
          </div>
          <div class="value">
            <p-button label="Click" (click)="checkTwoFactorStatus()"></p-button>
            <span *ngIf="twoFactorAuthentication else FortwoFactorAuthenticationTag">{{'Enable' | translate}}</span>
            <ng-template #FortwoFactorAuthenticationTag>
              <span>{{'Disable' | translate}}</span>
            </ng-template>
            <p-toggleswitch [(ngModel)]="twoFactorAuthentication"></p-toggleswitch>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="form-group" *ngIf="!isProd">
    <div class="title">
      <label class="h5">{{'Social Account Combination' | translate}}</label>
    </div>
  </div>
  <div class="page-filter clearfix account" *ngIf="!isProd">
    <div class="index-content page-account page-plan border-bottom">
      <div class="form-group">
        <div class="flex">
          <div class="title flex">
            <span class="fa-stack fa-lg">
              <i class="fa fa-circle fa-stack-2x apple"></i>
              <i class="fa fa-apple fa-stack-1x fa-inverse"></i>
            </span>
            <div class="title-content">
              <label>{{'Apple' | translate}}</label>
              <small *ngIf="appleChecked">{{'Connect with' | translate}} <strong>{{OAuthAppleEmail}}</strong></small>
            </div>
          </div>
          <div class="value">
            <p-button label="Click" (click)="checkSocialCombineStatus('apple')"></p-button>
            <span *ngIf="appleChecked else appleCheckedTag">{{'Enable' | translate}}</span>
            <ng-template #appleCheckedTag>
              <span>{{'Disable' | translate}}</span>
            </ng-template>
            <p-toggleswitch [(ngModel)]="appleChecked" disabled></p-toggleswitch>
          </div>
        </div>
      </div>
    </div>
    <div class="index-content page-account page-plan border-bottom">
      <div class="form-group">
        <div class="flex">
          <div class="title flex">
            <span class="fa-stack fa-lg">
              <i class="fa fa-circle fa-stack-2x google"></i>
              <i class="fa fa-google fa-stack-1x fa-inverse"></i>
            </span>
            <div class="title-content">
              <label>{{'Google' | translate}}</label>
              <small *ngIf="googleChecked">{{'Connect with' | translate}} <strong>{{OAuthGoogleEmail}}</strong></small>
            </div>
          </div>
          <div class="value">
            <p-button label="Click" (click)="checkSocialCombineStatus('google')"></p-button>
            <span *ngIf="googleChecked else googleCheckedTag">{{'Enable' | translate}}</span>
            <ng-template #googleCheckedTag>
              <span>{{'Disable' | translate}}</span>
            </ng-template>
            <p-toggleswitch [(ngModel)]="googleChecked" disabled></p-toggleswitch>
          </div>
        </div>
      </div>
    </div>
    <!-- 2026/07/21 kyrie.hung 移除 Facebook 社群帳號綁定功能
    <div class="index-content page-account page-plan">
      <div class="form-group">
        <div class="flex">
          <div class="title flex">
            <span class="fa-stack fa-lg">
              <i class="fa fa-circle fa-stack-2x facebook"></i>
              <i class="fa fa-facebook fa-stack-1x fa-inverse"></i>
            </span>
            <div class="title-content">
              <label>{{'Facebook' | translate}}</label>
              <small *ngIf="facebookChecked">{{'Connect with' | translate}} <strong>{{OAuthFacebookEmail}}</strong></small>
            </div>
          </div>
          <div class="value">
            <p-button label="Click" (click)="checkSocialCombineStatus('facebook')"></p-button>
            <span *ngIf="facebookChecked else facebookCheckedTag">{{'Enable' | translate}}</span>
            <ng-template #facebookCheckedTag>
              <span>{{'Disable' | translate}}</span>
            </ng-template>
            <p-toggleswitch [(ngModel)]="facebookChecked" disabled></p-toggleswitch>
          </div>
        </div>
      </div>
    </div>
    -->
  </div>
</section>


<p-popover #twoFactorInfo class="infoPanel batteryHealth" [style]="{ 'max-width': '400px' }">
  <div>
    <ol>
      <li translate>Two-Factor Authentication is a more secure function to protect user's PowerPanel Cloud account.</li>
      <li translate>Ticking Enable will require user to take two steps, enter both account information and OTP, to log in to PowerPanel Cloud.</li>
      <li><strong translate>Please be noted that any changes will take effect on both PowerPanel Cloud App and Website.</strong></li>
    </ol>
  </div>
</p-popover>


<app-dialog (connectEvt)="confirmTwoFactorEnable($event);confirmTwoFactorDisable($event);confrimOTPnumber($event);confrimCombineLogin($event);cancelSocialCombine($event);confirmSocialPasswordSetup($event);"></app-dialog>
<p-toast [style]="{marginTop: '70px'}"></p-toast>
